import { useEffect } from "react";

export const useColumnPinning = ({ apiRef, columnsDependency }) => {
  useEffect(() => {
    let unsubscribe;
    let mutationObserver;
    const disableColumnVirtualization = () => {
      if (apiRef.current?.unstable_setColumnVirtualization) {
        apiRef.current.unstable_setColumnVirtualization(false);
        return true;
      }
      return false;
    };
    const setupEventSubscription = () => {
      if (!unsubscribe && apiRef.current) {
        try {
          unsubscribe = apiRef.current.subscribeEvent("columnsChange", () => {
            disableColumnVirtualization();
          });
        } catch {}
      }
    };

    if (disableColumnVirtualization()) {
      setupEventSubscription();
    }

    mutationObserver = new MutationObserver(() => {
      if (disableColumnVirtualization()) {
        setupEventSubscription();
      }
    });
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
    return () => {
      if (unsubscribe) unsubscribe();
      if (mutationObserver) mutationObserver.disconnect();
    };
  }, [apiRef, columnsDependency]);
};
